import type { Kit, KitAvailabilityStatus } from '@cheqroom/api';

const canBook = (availability: KitAvailabilityStatus) =>
	availability === 'available' || availability === 'available_partially';

/**
 * An available kit reads "Unavailable" when the user can read reservations and/or checkouts, and
 * the kit can be booked through none of the ones they can read.
 */
export const isKitUnavailable = (
	kit: Pick<Kit, 'status' | 'canReserve' | 'canOrder'>,
	canReadCheckouts: boolean,
	canReadReservations: boolean
): boolean => {
	if (kit.status !== 'available') return false;
	if (!canReadCheckouts && !canReadReservations) return false;
	if (canReadReservations && canBook(kit.canReserve)) return false;
	if (canReadCheckouts && canBook(kit.canOrder)) return false;

	return true;
};
